import { forwardRef } from 'react';

import { Formula } from 'Blocks/Formula';

import { formula } from 'assets/content/landingPages/stylingGel';

import { CTA } from './CTA';

type StylingGelFormulaProps = {
  dataTestId?: string;
  id?: string;
  isCoilyVariant?: boolean;
};

export const StylingGelFormula = forwardRef<HTMLElement, StylingGelFormulaProps>(
  ({ dataTestId, id, isCoilyVariant = false }, ref) => {
    const { title, description, naturalIngredients, formulaImages, altFormulaImages } = formula;
    return (
      <Formula
        ref={ref}
        dataTestId={dataTestId}
        description={description}
        formulaImages={!isCoilyVariant ? formulaImages : altFormulaImages}
        hasUncroppedMobileImage
        id={id}
        naturalIngredients={naturalIngredients}
        title={title}
      >
        <CTA dataFrom="ingredients-module" label="formula" variant="underlinedBlack" />
      </Formula>
    );
  },
);

StylingGelFormula.displayName = 'StylingGelFormula';
